import React from 'react'
import Register from '../components/Register'

const Registration = () => {
  return (
    <Register/>
  )
}

export default Registration